import dayjs, { Dayjs } from 'dayjs';

/**
 * dayjs equivalent of moment.parseZone() — preserves the timezone offset
 * from the input string so times display as-is (e.g. "9:00 AM" stays
 * "9:00 AM" regardless of the browser's local timezone).
 *
 * Works by stripping the timezone offset/Z suffix before parsing,
 * so dayjs treats the time values as local.
 */
export default function parseZone(dateStr: string | null | undefined): Dayjs {
  if (!dateStr) return dayjs(dateStr);
  return dayjs(dateStr.replace(/([+-]\d{2}:\d{2}|Z)$/, ''));
}
